<div class="header">
  <ion-icon class="close-icon" name="close-outline" (click)="onCancel()">
  </ion-icon>
</div>

<div class="search-filter-container">
  <!-- Normal view - only show when filter view is not active -->
  <ng-container *ngIf="!showFilterView">
    <h2 class="title">{{ title }}</h2>
    <div
      class="search-container"
      [ngClass]="
        platformType === platformRef.mobile
          ? 'mobile'
          : platformType === platformRef.tablet
            ? 'tablet'
            : ''
      "
    >
      <ion-searchbar
        class="search"
        [placeholder]="searchPlaceholder"
        [value]="searchQuery"
        (ionInput)="onSearch($event)"
        data-cy="ai-list-ingredient-menu-searchbar"
        showCancelButton="never"
        animated
      >
      </ion-searchbar>

      <app-sort-and-filter-button
        [sortAndFilterText]="'i18n.lists.filter'"
        [sortAndFilterCount]="selectedFilterCount"
        [platformType]="platformType"
        [showClearAll]="false"
        (openSortAndFilterListModalEmitter)="onFilter()"
        data-cy="ai-list-ingredient-menu-filter-button"
      ></app-sort-and-filter-button>
    </div>
  </ng-container>

  <!-- Filter view - only show when filter view is active -->
  <ng-container *ngIf="showFilterView">
    <div class="filter-header">
      <ion-icon
        class="back-icon"
        src="assets/icon/chevron-left.svg"
        (click)="resetFilterView()"
      ></ion-icon>
      <h2 class="filter-title">{{ 'i18n.lists.filter' | translate }}</h2>
    </div>
    <div class="filter-options">
      <ion-item
        *ngFor="let option of filterOptions"
        [class.selected]="option.selected"
        (click)="toggleFilterOption(option)"
        attr.data-cy="filter-option-{{ option.id }}"
        lines="none"
      >
        <ion-label
          [id]="option.id"
          class="filter-option"
          attr.data-cy="filter-option-label-{{ option.id }}"
        >
          {{ option.label | translate }}
        </ion-label>
        <app-usf-checkbox
          *ngIf="platformType === platformRef.mobile"
          [attr.aria-labelledby]="option.id"
          [invertColors]="true"
          [isSelected]="option.selected"
          attr.data-cy="filter-option-checkbox-{{ option.id }}"
          slot="end"
        ></app-usf-checkbox>
        <ion-checkbox
          *ngIf="platformType !== platformRef.mobile"
          [attr.aria-labelledby]="option.id"
          [checked]="option.selected"
          attr.data-cy="filter-option-checkbox-{{ option.id }}"
          slot="end"
        ></ion-checkbox>
      </ion-item>
    </div>
  </ng-container>
</div>

<div class="content-container">
  <div
    class="ingredients-container"
    [class.loaded]="loadingState === 'loaded' && ingredients?.length > 0"
    *ngIf="!showFilterView"
  >
    <div
      *ngIf="loadingState !== 'loaded' || loading"
      class="loading-container"
      [ngClass]="
        platformType === platformRef.mobile
          ? 'mobile'
          : platformType === platformRef.tablet
            ? 'tablet'
            : ''
      "
    >
      <div class="loading-text">
        {{ 'i18n.lists.aiListEditMenu.loadingSpinnerMessage' | translate }}
      </div>
      <ion-spinner name="circles"></ion-spinner>
    </div>

    <div
      *ngIf="loadingState === 'loaded' && ingredients?.length > 0"
      class="ingredients-list"
      [ngClass]="
        platformType === platformRef.mobile
          ? 'mobile'
          : platformType === platformRef.tablet
            ? 'tablet'
            : ''
      "
    >
      <ng-container *ngFor="let ingredient of ingredients; let i = index">
        <app-ai-list-ingredient-menu-product-card
          [product]="ingredient"
          [selected]="isProductSelected(ingredient)"
          (selectionChanged)="onProductSelected($event)"
        ></app-ai-list-ingredient-menu-product-card>
      </ng-container>
    </div>

    <div
      *ngIf="loaded && !loading && ingredients?.length === 0"
      class="no-products-container"
      [ngClass]="
        platformType === platformRef.mobile
          ? 'mobile'
          : platformType === platformRef.tablet
            ? 'tablet'
            : ''
      "
    >
      <div class="no-products-text">
        {{ 'i18n.lists.aiListEditMenu.noProductsFound' | translate }}
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<div class="footer">
  <ion-buttons>
    <ion-button
      expand="block"
      [ngClass]="
        platformType !== platformRef.mobile
          ? 'usf-outline-green-dsktp-tblt-modal-button'
          : 'usf-outline-green-mobile-modal-button'
      "
      (click)="onCancel()"
    >
      {{ 'i18n.common.cancel' | translate }}
    </ion-button>
    <ion-button
      expand="block"
      [ngClass]="
        platformType !== platformRef.mobile
          ? showFilterView
            ? shouldEnableSaveInFilterView()
              ? 'usf-fill-green-dsktp-tblt-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
            : (selectedProduct$ | async)
              ? 'usf-fill-green-dsktp-tblt-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
          : showFilterView
            ? shouldEnableSaveInFilterView()
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-disabled-mobile-modal-button'
            : (selectedProduct$ | async)
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-disabled-mobile-modal-button'
      "
      [disabled]="
        showFilterView
          ? !shouldEnableSaveInFilterView()
          : (selectedProduct$ | async) === null ||
            (selectedProduct$ | async) === undefined
      "
      (click)="onSave($event)"
    >
      {{ 'i18n.common.save' | translate }}
    </ion-button>
  </ion-buttons>
</div>
